import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { textStyles } from "ui";
import styles from "./Root.module.css";

type Props = ComponentProps["Generic"]["Popover"]["Root"];

export const Root = ({ children, opened }: Props) => {
  return <div className={classNames(textStyles.neutral600, styles.root, { [styles.opened]: opened })}>{children}</div>;
};
